// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1LvwW","detailsBorder":"styles_detailsBorder__17BnY"};